import React from 'react';
import cn from 'classnames';
import { map } from 'lodash';
import './Tabs.scss';

interface GetStyleOptions {
    isActive: boolean;
    isDisabled: boolean;
    prefix?: string;
}

interface OwnProps {
    activeTab: any;
    data: {
        [value: string]: string;
    };
    changeActiveTab: (activeTab: any) => void;
    disabledTabs?: any[];
    styleName?: string;
    className?: string;
    extraTab?: JSX.Element;
}

type Props = OwnProps;

export default class Tabs extends React.Component<Props> {
    getStyleNames({ isActive, isDisabled, prefix = '' }: GetStyleOptions) {
        return cn(`${prefix}tab`, {
            [prefix + 'is-active']: isActive,
            [prefix + 'is-disabled']: isDisabled,
        });
    }

    render() {
        const { data, changeActiveTab, className } = this.props;

        const { activeTab, disabledTabs, extraTab } = this.props;

        return (
            <div styleName="tabs" className={cn('__app-Tabs-tabs ', className)}>
                {map(data, (title, value) => {
                    const isActive = activeTab === value;
                    const isDisabled =
                        !!disabledTabs && disabledTabs.includes(value);

                    const handleChooseTab =
                        !isActive && !isDisabled
                            ? changeActiveTab.bind(this, value)
                            : undefined;

                    const tabState = {
                        isActive,
                        isDisabled,
                    };

                    return (
                        <div
                            className={this.getStyleNames({
                                ...tabState,
                                prefix: '__app-Tabs-',
                            })}
                            styleName={this.getStyleNames({
                                ...tabState,
                            })}
                            onClick={handleChooseTab}
                            key={value}
                        >
                            {title}
                        </div>
                    );
                })}
                {extraTab}
            </div>
        );
    }
}
